import React from 'react';
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';
import Pagination from '@mui/material/Pagination';
import {
  DataGrid,
  GridFooterContainer,
  useGridApiContext,
  useGridSelector,
  gridPageSelector,
  gridPageCountSelector,
  gridRowCountSelector
} from '@mui/x-data-grid';
import styles from '../../../style';
import PropTypes from 'prop-types';

function CustomFooter() {
  const apiRef = useGridApiContext();
  const page = useGridSelector(apiRef, gridPageSelector);
  const pageCount = useGridSelector(apiRef, gridPageCountSelector);
  const rowCount = useGridSelector(apiRef, gridRowCountSelector);

  return (
    <GridFooterContainer>
      <Box
        sx={{
          width: '100%',
          px: 2,
          py: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}
      >
        <Box sx={{ fontSize: '14px', color: '#666' }}>
          Toplam Sayfa: {pageCount} | Toplam Kayıt: {rowCount}
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Box sx={{ fontSize: '14px', color: '#666' }}>
            Sayfa {page + 1} / {pageCount || 1}
          </Box>

          <Pagination
            count={pageCount || 1}
            page={page + 1}
            onChange={(event, value) => apiRef.current.setPage(value - 1)}
            size="small"
            sx={{
              '& .MuiPaginationItem-root': {
                color: '#666'
              },
              '& .Mui-selected': {
                backgroundColor: '#E6F0FF !important',   // arka plan
                color: '#18428F',                        // yazı rengi
                fontWeight: 'bold'
              },
              '& .Mui-selected:hover': {
                backgroundColor: '#D6E4FF'
              }
            }}
          />
        </Box>
      </Box>
    </GridFooterContainer>
  );
}

class ShowReportGrid extends React.Component {
  render() {
    const data = this.props.data || [];
    const columns = this.props.columns || [];

    return (
      <div>
        {data.length > 0 ? (
          <Box sx={{ width: '100%' }}>
            <Box sx={{ height: 500, mt: 1 }}>
              <DataGrid
                rows={data}
                columns={columns}
                getRowId={(row) => row.approvalId}
                onRowClick={this.props.handleRowClick}
                pageSize={20}
                rowsPerPageOptions={[20]}
                pagination
                getRowHeight={() => 'auto'}
                disableColumnMenu
                components={{
                  Footer: CustomFooter
                }}
                sx={{
                  '& .MuiDataGrid-row': {
                    minHeight: '40px !important'
                  },
                  '& .MuiDataGrid-cell': styles.showReportGrid
                }}
              />
            </Box>
          </Box>
        ) : (
          <Alert className='customAlert' severity="info">
            <div style={styles.alert}>Girdiğiniz kriterlerde herhangi bir süreciniz bulunmuyor.</div>
            <div style={styles.alertDescription}>Girmiş olduğunuz filtre değerlerini değiştirerek tekrar deneyebilirsiniz.</div>
          </Alert>
        )}
      </div>
    );
  }
}

ShowReportGrid.propTypes = {
  data: PropTypes.array,
  columns: PropTypes.array,
  handleRowClick: PropTypes.func.isRequired,
};

export default ShowReportGrid;